import { OtpSetupForm } from '@/modules/Users/OtpSetup.form';

const OtpSetup = () => <OtpSetupForm />;

export default OtpSetup;
